import dayjs from 'dayjs';

dayjs.locale('ko');

export const formatDate = (dateString: string | Date, format: string = 'YY.MM.DD HH:mm') => {
  if (!dateString) return '';
  return dayjs(dateString).format(format);
};
